// extracted by css-extract-rspack-plugin
export default {"cls1":"TriagePage-cls1_rxt","cls2":"TriagePage-cls2_exm TriagePage-cls1_rxt"};